function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: -0.000488281,
  width: 35.0005,
  height: 35,
  rx: 3,
  fill: "#201D2F"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: -0.5,
  y: 0.5,
  width: 22,
  height: 7,
  rx: 3.5,
  transform: "matrix(-1 0 0 1 29.1934 15.5607)",
  stroke: "#F0F0F5"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M24.6935 19.5607C24.6935 20.4076 25.349 21.0607 26.1172 21.0607C26.8854 21.0607 27.541 20.4076 27.541 19.5607C27.541 18.7138 26.8854 18.0607 26.1172 18.0607C25.349 18.0607 24.6935 18.7138 24.6935 19.5607Z",
  stroke: "#F0F0F5"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M19.6935 19.5607C19.6935 20.4076 20.349 21.0607 21.1172 21.0607C21.8854 21.0607 22.541 20.4076 22.541 19.5607C22.541 18.7138 21.8854 18.0607 21.1172 18.0607C20.349 18.0607 19.6935 18.7138 19.6935 19.5607Z",
  stroke: "#F0F0F5"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M14.6935 19.5607C14.6935 20.4076 15.349 21.0607 16.1172 21.0607C16.8854 21.0607 17.541 20.4076 17.541 19.5607C17.541 18.7138 16.8854 18.0607 16.1172 18.0607C15.349 18.0607 14.6935 18.7138 14.6935 19.5607Z",
  stroke: "#F0F0F5"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M9.69347 19.5607C9.69347 20.4076 10.349 21.0607 11.1172 21.0607C11.8854 21.0607 12.541 20.4076 12.541 19.5607C12.541 18.7138 11.8854 18.0607 11.1172 18.0607C10.349 18.0607 9.69347 18.7138 9.69347 19.5607Z",
  stroke: "#F0F0F5"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: -0.5,
  y: 0.5,
  width: 17,
  height: 6.12143,
  rx: 2.5,
  transform: "matrix(-1 0 0 1 26.6934 9.43929)",
  stroke: "#F0F0F5"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M9.52875 16.395L9.52875 12.5629C9.52875 11.7039 8.83238 11.0075 7.97336 11.0075V11.0075C7.11434 11.0075 6.41797 11.7039 6.41797 12.5629L6.41797 24.0053C6.41797 24.8644 7.11434 25.5607 7.97336 25.5607V25.5607C8.83238 25.5607 9.52875 24.8644 9.52875 24.0053L9.52875 22.5607",
  stroke: "#F0F0F5"
});

var _ref10 = /*#__PURE__*/React.createElement("line", {
  x1: 0.5,
  y1: -0.5,
  x2: 1.5,
  y2: -0.5,
  transform: "matrix(-1 0 0 1 6.80664 23.9437)",
  stroke: "#F0F0F5",
  strokeLinecap: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("line", {
  x1: 0.5,
  y1: -0.5,
  x2: 1.5,
  y2: -0.5,
  transform: "matrix(-1 0 0 1 6.80664 20.7097)",
  stroke: "#F0F0F5",
  strokeLinecap: "round"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M6.30664 16.9756L5.25673 16.9756",
  stroke: "#F0F0F5",
  strokeLinecap: "round"
});

var _ref13 = /*#__PURE__*/React.createElement("line", {
  x1: 0.5,
  y1: -0.5,
  x2: 1.5,
  y2: -0.5,
  transform: "matrix(-1 0 0 1 6.80664 14.2416)",
  stroke: "#F0F0F5",
  strokeLinecap: "round"
});

function SvgTrancher(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrancher);
export default __webpack_public_path__ + "static/media/trancher.5b02a447.svg";
export { ForwardRef as ReactComponent };